<template>
    <i v-if="designMode" style="font-size:36px" class="pi pi-clock"></i>
</template>

<script>
import { onUnmounted, watchEffect } from '@vue/runtime-core'
export default {
    name: 'tw-timer',
    props: {
        interval: {
            type: Number,
            default: 1000
        },
        enabled: {
            type: Boolean,
            default: false
        }
    },
    emits: {
        "elapsed": null
    },
    setup(props, context) {
        const designMode = window.site && window.site.designMode;
        let handle = -1
        
        watchEffect(() => {
            if (handle !== -1) {
                clearInterval(handle)
                handle = -1
            }

            if (props.enabled) {
                handle = setInterval(() => {
                    context.emit('elapsed' )
                }, props.interval)
            }
        })

        onUnmounted(() => {
            if (handle !== -1) {
                clearInterval(handle)
                handle = -1
            }
        })

        return {
            designMode
        }
    }
}
</script>

<style>

</style>